import "./AppPortal.css";

import { useRenderEditor, useRenderNotificationContainer, useRenderPopup } from "../../infrastructure/ui/UIServices";

import { NotificationContainer } from "../../components/notifications/NotificationContainer";
import { PopupArea } from '../containers/popup-area/PopupArea';

export interface IAppPortalProps {
    children: React.ReactNode;
}


export function AppPortal(props: IAppPortalProps) {
    const { showPopup, popupContent } = useRenderPopup();
    const { showEditor, editorContent} = useRenderEditor();
    const { showNotificationContainer } = useRenderNotificationContainer();

    return (
        <div className="app-portal">
            {props.children}

            {showEditor ? <PopupArea>{editorContent}</PopupArea> : null}
            {showPopup ? <PopupArea>{popupContent}</PopupArea> : null}
            {showNotificationContainer ? <NotificationContainer /> : null}
        </div>
    )
}
